import React, { useEffect } from 'react';
import { useGame } from '../../contexts/GameContext';
import NotificationContainer from '../ui/NotificationContainer';

const GameLayout = ({ children }) => {
  const { state, dispatch } = useGame();

  // 頁面可見性API支援
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && state.autoTapActive) {
        // 頁面隱藏時暫停自動敲擊
      } else if (!document.hidden && state.autoTapActive) {
        // 頁面顯示時恢復自動敲擊
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [state.autoTapActive]);

  // 鍵盤支援
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === 'Space' && event.target === document.body) {
        event.preventDefault();
        dispatch({ type: 'TAP_MOKUGYO' });
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [dispatch]);

  return (
    <div className="game-layout">
      {children}
      <NotificationContainer />
    </div>
  );
};

export default GameLayout;